(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lr-editorial-home"] && !Shopify.designMode) return;
  try {
    
function initializeLRHomepageFilms() {
  document.querySelectorAll('[data-lr-homepage-film]').forEach(function (video) {
    if (video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var limitedData = navigator.connection && navigator.connection.saveData;
    if (!reducedMotion && !limitedData) {
      video.muted = true;
      video.play().catch(function () {});
    }
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLRHomepageFilms);
} else {
  initializeLRHomepageFilms();
}
document.addEventListener('shopify:section:load', initializeLRHomepageFilms);

  } catch(e) { console.error(e); }
})();
})();
